import { Switch } from "react-router-dom";

import MiddlewareRoute from "../Middleware";

import { GlobalVariables } from "../../GlobalVariables";
import ConectaZapPage from "../../pages/conectaZap/ConectaZapPage";
import { ConectaZapContextProvider } from "../../pages/conectaZap/context/ConectaZapContext";

export default function ConectaZapModule() {
  return (
    <Switch>
      <ConectaZapContextProvider>
        <MiddlewareRoute
          path="/whatsapp"
          sidebar
          component={ConectaZapPage}
          noPaddingSidebar
          routePermissionId={GlobalVariables.PERMISSIONS.CONECTA_ZAP}
        />
      </ConectaZapContextProvider>
    </Switch>
  );
}
